import {AbstractEvent} from "@/modules/base/events";

export class BeforeSponsoringOffersCreationEvent extends AbstractEvent {
}